import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { Privileges } from 'src/app/core/privileges/privileges';
import { CancelDocumentReadReceiptRequest } from 'src/app/document-user/state/document.actions';

@Component({
  selector: 'app-document-read-receipt-requests-template',
  templateUrl: './document-read-receipt-requests-template.component.html',
  styleUrls: ['./document-read-receipt-requests-template.component.scss'],
  standalone: false,
})
export class DocumentReadReceiptRequestsTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  Privileges = Privileges;

  constructor(private store: Store) {}

  cancelRequest(): void {
    if (!this.element?.documentId || !this.element?.id) {
      return;
    }

    this.store.dispatch(
      new CancelDocumentReadReceiptRequest(this.element.documentId, this.element.id)
    );
  }
}
